var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacaciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3B88C3",
    cx: 18,
    cy: 30.54,
    rx: 18,
    ry: 5.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#88C9F9",
    d: "M33.813 28.538c0 1.616-2.5 2.587-14.482 2.587c-10.925 0-13.612-.971-13.612-2.587s5.683-2.926 13.612-2.926s14.482 1.31 14.482 2.926z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M7 28.25c0-1 1-5 11-5c12 0 15 4 15 5s0 2-14 2c-12 0-12-1-12-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M20.62 27.667a1.284 1.284 0 0 1-2.51-.545l5.083-25.985a1.284 1.284 0 1 1 2.508.545L20.62 27.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2E44",
    d: "M24.358 1.827C16.736.173 9.501 3.7 8.198 9.705c0 0-.363 1.672.474 1.854c.836.182 2.872-1.128 2.872-1.128l20.908 4.538s1.309 2.036 2.146 2.218c.837.182 1.199-1.491 1.199-1.491C37.101 9.69 31.979 3.481 24.358 1.827z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE8B6",
    d: "M24.358 1.827C18.584.574 12.847 4.426 11.544 10.43c0 0-.363 1.673 1.31 2.036c1.673.364 4.545-.765 4.545-.765l9.199 1.997s2.146 2.217 3.819 2.581c1.673.362 2.035-1.311 2.035-1.311c1.303-6.004-2.321-11.888-8.094-13.141z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2E44",
    d: "M24.358 1.827c-3.003-.651-5.657 3.87-6.96 9.874c0 0 2.146 2.218 3.818 2.58l.837.183c1.673.362 4.544-.766 4.544-.766c1.304-6.004.764-11.219-2.239-11.871z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M15.844 27.948c.469-.427 1.75-.326 2.5-.602s1.219-.627 1.844-.376s.812.627 1.406.678s1.031.402.781.678s-2.219.376-3.531.376s-3.579-.226-3-.754z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacaciones);
export default __webpack_public_path__ + "static/media/vacaciones.162acfc907c2d089fb597137c878e1fb.svg";
export { ForwardRef as ReactComponent };